export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-reddit-2348f1c8b2e98cbb36f9ec71c55d99f7.svg";